<template>  
  <!-- View Detail Main Start -->
  <b-modal
    v-model="showProductModal"
    size="md"
    scrollable
    title-class="font-18"
    hide-footer
    @hidden="onProductModalHide"
  >
    <template #modal-header="{ close }">
      
      <!-- Emulate built in modal header close button action -->
      <h5>
        {{trans.get('__JSON__.Order No')+' '+(order && order.hash_id || '000')}}
        <span class="badge badge-pill badge-soft-primary font-size-12" v-if="order && order.delivery_pickup_types == 'Delivery'">
          {{trans.get('__JSON__.'+order && order.delivery_pickup_types)}}
        </span>
        <span class="badge badge-pill badge-soft-danger font-size-12" v-if="order && order.delivery_pickup_types == 'Takeaway'">
          {{trans.get('__JSON__.'+order && order.delivery_pickup_types)}}
        </span>
        <span class="badge badge-pill badge-soft-danger font-size-12" v-if="order && order.delivery_pickup_types == 'Pickup'">
          {{trans.get('__JSON__.'+order && order.delivery_pickup_types)}}
        </span>
        <span class="badge badge-pill font-size-12" :class="{'badge-soft-success': order && (order.payment_method == 'Cash On Delivery'),'badge-soft-warning':order && (order.payment_method != 'Cash On Delivery')}">
              {{order && (order.payment_method == 'Cash On Delivery'?'COD':order.payment_method.name)}}
        </span>
        <span class="badge badge-pill font-size-12" :class="{'badge-soft-danger':order &&(order.cancelled_by != null )}">
            {{order && (order.cancelled_by != null) ? 'cancel' : ''}}
        </span>
        <span v-if="(order && order.order_status == 'PaymentPending') || (order && order.order_status == 'PaymentFailure')" class="badge badge-pill font-size-12"  :class="{'badge-soft-warning': (order && order.order_status == 'PaymentPending'),'badge-soft-danger':(order && order.order_status == 'PaymentFailure')}">
          {{order && order.order_status == 'PaymentPending' ? 'Pending': 'Failed'}}
        </span>
        <h6 class="font-color mt-2"><span>{{trans.get('__JSON__.TimeSlot')  }}: {{ fromTime }} - {{ toTime }} Uhr</span></h6>
      </h5>
      <div>
        <button @click="close()" class="close">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </template>
    <div class="row">
      <div class="col-12">
        <p>
          <h5>
            <b>{{trans.get('__JSON__.Change Number Of Products')}}</b>
          </h5>
        
       
          <div class="product-slidelist-main"> 
            <div class="prdtslidelist-content d-flex align-items-end justify-content-between">
              <div class="d-flex align-items-start">
                <div class="prdtslidelist-img">
                  <div v-if="productData.sub_products[0].image">
                    <img alt title="image" class="vendor-img avatar-xs" :src="config.sub_product+productData.sub_product_id+'/original/'+productData.sub_products[0].image"/>   
                  </div>
                  <div v-else>
                    <img class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt/>
                  </div>
                </div>
                <div>
                  <h6 class="prdtslidelist-heading f-23 f-black">{{productData.sub_products[0].product.item_name}}</h6>
                  <span>{{productData.sub_products[0].selling_qty}} x {{productData.sub_products[0].size_attribute.size.att_name}} ({{productData.sub_products[0].size_attribute.material.att_name}})</span>
                  <br/>
                  <span>{{ price }}</span><span>€</span>
                </div>
              </div> 
                <div>
                  <div class="wrapper-count">
                    <input class="count-btn btn--minus" type="button" name="button" value="-" @click="changeCounter('-1')">
                    <input class="quantity-count" type="text" name="name" :value="counter">
                    <input class="count-btn btn--plus" type="button" name="button" value="+" @click="changeCounter('1')">
                  </div>
                </div>                       
            </div>
          </div>
          <br />
          <div v-if="isHide">
            <span><b>{{trans.get('__JSON__.Select Reason')}}</b></span>
            <div class="border my-2 p-2 d-flex align-items-center justify-content-between">
              <label for="Product Broken" class="mb-0">{{trans.get('__JSON__.Product Broken')}}</label>
              <input type="radio" name="cancel_reason" value="broken" @change="onChange($event)" :disabled="this.is_disabled">
            </div>
            <div class="border mb-2 p-2 d-flex align-items-center justify-content-between">
              <label for="Other Reason" class="mb-0">{{trans.get('__JSON__.Would Not Exist')}}</label>
              <input type="radio" name="cancel_reason" value="missing" @change="onChange($event)" :disabled="this.is_disabled">
            </div>
            <div class="border mb-2 p-2 d-flex align-items-center justify-content-between">
              <label for="Other Reason" class="mb-0">{{trans.get('__JSON__.Other Reason')}}</label>
              <input type="radio" name="cancel_reason" value="2" @change="onChange($event)" :disabled="this.is_disabled">
            </div>
            <div v-if="!isEnable">
            <span><b>{{trans.get('__JSON__.Mesaage to headquarters')}}</b></span>
            <br />
              <textarea  rows="4" cols="50"
                :placeholder="trans.trans('__JSON__.News')"
                id="reason"
                name="reason"
                class="mt-2 reason"
                v-model="cancelReason"
              >
              </textarea>
            </div>
          </div>
         
        </p>
        <div class="">
        <!-- :disabled="isEnableSubmit"  -->
          <button @click="submit" class="btn btn-outline--primary" :disabled="isEnableSubmit">Speichern</button>
        </div>
        <!-- <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
            <strong>{{trans.get('__JSON__.Loading...')}}</strong>
        </div> -->
    </div>
     
      <!-- <div class="table-responsive item-order-main">
        <table class="table table-centered table-bordered item-table-main">
          <thead>
            <tr>
              <th scope="col" class="item-name-main">{{trans.get('__JSON__.Item Name')}}</th>
              <th scope="col">{{trans.get('__JSON__.Qty.')}}</th>
              <th scope="col">{{trans.get('__JSON__.Size')}}</th>
              <th scope="col">{{trans.get('__JSON__.Material')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>
                  <div v-if="productData.sub_products[0].image">
                    <img alt title="image" class="vendor-img avatar-xs" :src="productData.sub_products[0].image_path"/>   
                  </div>
                  <div v-else>
                    <img class="avatar-md rounded-circle-banner" src="http://localhost/drinkspot/public/images/no-img.png"/>
                  </div>
                  {{ productData.sub_products[0].product.item_name }}
                </p>
                <p>{{ productData.sub_products[0].selling_qty }} x {{ productData.sub_products[0].size_attribute.size.att_name }} ({{productData.sub_products[0].size_attribute.material.att_name}})
                </p>
                <p>
                  <span>ArtNr: {{ productData.sub_products[0].product_number }}</span>
                  <span class="ml-5">EAN: {{ productData.sub_products[0].barcode_number }}</span>
                </p>
              </td>
              <td align="center">
                <div class="wrapper-count">
                  <input class="count-btn btn--minus" type="button" name="button" value="-" @click="changeCounter('-1')">
                  <input class="quantity-count" type="text" name="name" :value="counter">
                  <input class="count-btn btn--plus" type="button" name="button" value="+" @click="changeCounter('1')">
                </div>

              </td>
              <td align="center">
                <p>{{ productData.sub_products[0].size_attribute.size.att_name }}</p>
              </td>
              <td align="center">
                <p>{{ productData.sub_products[0].size_attribute.material.att_name }}</p>
              </td>
            </tr>
          </tbody>
        </table>
        
      </div> -->
      <!-- <div class="col-12">
        <input type="radio" id="cancel_reason" name="cancel_reason" value="0" @change="onChange($event)">
        <label for="Product Broken" class="mr-5">{{trans.get('__JSON__.Product Broken')}}</label>
        <input type="radio" id="cancel_reason" name="cancel_reason" value="1" @change="onChange($event)">
        <label for="Other Reason">{{trans.get('__JSON__.Other Reason')}}</label>
      </div>
      <div class="col-12" v-if="!isEnable">
        <textarea 
        :placeholder="trans.trans('__JSON__.Enter Message')"
        id="reason"
        name="reason"
        v-model="cancelReason"
        >
        </textarea>
      </div> -->
          <!-- View Detail Main End -->
      <!-- <button style="float: right !important; background-color:#b8c8e5; border-color:#b8c8e5;" @click="submit" :disabled="isEnableSubmit">Submit</button> -->
    </div>
    <!-- Confirmation Modal Start -->
     <template>
        <b-modal
          v-model="showConfirmationModal"
          size="md"
          class="centered-modal"
          hide-footer
        >
        <template #modal-header="{ close }">
          <!-- Optionally include a close button or other content here -->
          <h5 class="custom-title">Bestätigung</h5>
          <div>
            <button @click="close()" class="close">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </template>
        <div class="custom-modal-body">
          <div class="centered-modal">
            <p class="centered-modal-text">Bist du dir sicher, dass du diese Aktion fortführen willst? </p>
            <span>Du kannst diese Aktion nicht mehr rückgängig machen !</span>
          </div>
          <div class="custom-footer-buttons">
              <button class="btn btn-secondary" @click="cancelSubmit">Abbruch / Zurück</button>
              <button class="btn btn-primary" @click="confirmSubmit">Speichern</button>
          </div>
        </div>
          <template #modal-footer="{close}">
          </template>
        </b-modal>
      </template>
    <!-- Confirmation Modal End -->
  </b-modal>
   
</template>

<script>
import { orderService } from '../../../services'
import config from '../../../config'
import { error_message, success_message } from '../../../Helper/helper';
export default {
    props :['productData','loading','order'],
    data(){
        return {
            config:config,
            orderLoading: false,
            showProductModal: false,
            showConfirmationModal: false, // New data property
            product: null,
            amounts: '',
            singleProductCount: 0,
            boxCount: 0,
            qtyCount: 0,
            orderLoading: false,
            isEnable: true,
            counter: 0,
            cancelReason: null,
            isEnableSubmit: true,
            price: 0,
            pendingQty: null,
            fromTime: null,
            toTime: null,
            modelShow: false,
            lastIndex: 0,
            selectedValue: null,
            isHide: true,
            data_cancel:'',
            is_disabled:'',
            updateQuantity:'',
        }
    },
    mounted(){
      this.qtyCount = this.productData.pending_order_products.length > 0 ?this.productData.pending_order_products[this.lastIndex].total_quantity :this.productData.quantity ;

      if(this.productData.pending_order_products.length > 0){
        this.lastIndex = this.productData.pending_order_products.length - 1;
        // this.qtyCount = this.productData.pending_order_products[this.lastIndex].pending_quantity;
        this.pendingQty = this.productData.pending_order_products[this.lastIndex].pending_quantity;
        this.counter = this.productData.pending_order_products[this.lastIndex].pending_quantity;
        this.selectedValue = null;
      }
      else{
        // this.qtyCount = this.productData.quantity;
        this.counter = this.productData.quantity;
      }
      // console.log('this.qtyCount',this.qtyCount);
      // console.log('this.counter',this.counter);
      this.showProductModal = true;
      
      var fromTime = this.order.delivery_from_time.split(':');
      var toTime = this.order.delivery_to_time.split(':');
           
      this.fromTime = fromTime[0];
      this.toTime = toTime[0];

      if(this.order.user.user_role == 5){
        this.price = this.productData.sub_products[0].business_customer_price;
      }
      else{
        this.price = this.productData.sub_products[0].sale_price;
      }
     
    },
    methods : {
      viewDetails(){
        this.showProductModal = true;
        // this.orderLoading = true;
        // orderService.getOrderAdmin(this.orderId)
        //   .then(res => {
        //     this.order = res.data.result;
        //     console.log('this.order',this.order.order_item);
        //     this.orderLoading = false;
        //     var i = 0;
        //     var j = 0;
        //     this.order.order_item.map(function(value, key) {
        //       value.sub_products.map(function(value1, key1) {
        //         if(value1.product_box_id){
        //           i++;
        //         }
        //         else{
        //           j++;
        //         }
        //       });
        //     });
        //     this.singleProductCount = j;
        //     this.boxCount = i;
        //   })

        //   this.getOrderAmounts();
      },
      onProductModalHide(){
        this.showProductModal = false;
        this.$emit('hidden');
      },
      changeCounter: function(num){
        this.counter += +num
				!isNaN(this.counter) && this.counter > 0 ? this.counter : this.counter = 0;
        if(this.counter >= this.qtyCount){
          // this.counter = this.qtyCount;
          if(this.pendingQty <= this.qtyCount){
            // if(this.qtyCount === this.counter){
            //   console.log('qqqqqq')
            //   this.counter = this.productData.total_qty
            //   this.isHide = false;
            //   this.is_disabled = true;
            //   this.isEnableSubmit = false;
            // }
            if( this.counter >= this.qtyCount){
              // this.counter = this.productData.total_qty
              if(this.productData.total_qty === this.counter){
                if(this.productData.total_qty != undefined){
                  this.counter = this.productData.total_qty ;
                  this.isHide = false;
                  this.is_disabled = true;
                  this.isEnableSubmit = false;
                }else if(this.counter == this.productData.quantity){
                  this.counter =  this.qtyCount 
                  this.isEnableSubmit = true;
                  this.is_disabled = false;
                  this.isHide = true;
                  this.isEnable = true;
                }
               
              }else if(this.productData.total_qty > this.counter){
                // this.counter = this.productData.total_qty;
                this.isHide = true;
                this.is_disabled = false;
                this.isEnableSubmit = true;
              }else{
                if(this.counter < this.productData.quantity){
                  this.isHide = true;
                  this.is_disabled = false;
                  this.isEnableSubmit = true;
                }else if(this.counter > this.productData.quantity){
                  if(this.productData.quantity > this.productData.total_qty){
                      if(this.counter  > this.productData.quantity){
                        if(this.productData.total_qty != undefined){
                          this.counter =   this.qtyCount ;
                          this.isHide = true;
                          this.is_disabled = false;
                          this.isEnableSubmit = true;
                        }else if(this.counter == this.productData.quantity){
                          this.counter =   this.productData.total_qty ;
                          this.isEnableSubmit = true;
                          this.is_disabled = false;
                          this.isHide = true;
                          this.isEnable = true;
                        }else if(this.productData.total_qty == undefined){
                          this.counter = this.productData.quantity;
                          this.isHide = true;
                          this.is_disabled = false;
                          this.isEnableSubmit = true;
                        }
                        
                      }
                  }else{
                    if(this.productData.total_qty != undefined){
                      this.counter =  this.productData.total_qty;
                      this.isHide = false;
                      this.is_disabled = true;
                      this.isEnableSubmit = false;
                    }else if(this.counter == this.productData.quantity){
                      this.counter =  this.qtyCount ;
                      this.isEnableSubmit = true;
                      this.is_disabled = false;
                      this.isHide = true;
                      this.isEnable = true;
                    }else if(this.productData.total_qty == undefined){
                      this.counter = this.productData.quantity;
                      this.isHide = false;
                      this.is_disabled = true;
                      this.isEnableSubmit = false;
                    }
                   
                  }
                  // this.counter = this.productData.total_qty ?? this.productData.quantity;
                  // this.isHide = false;
                  // this.is_disabled = true;
                  // this.isEnableSubmit = false;
                }else if(this.productData.quantity == this.counter ){
                  // this.counter = this.productData.total_qty ?? this.productData.quantity;
                  this.isEnableSubmit = false;
                  this.is_disabled = true;
                  this.isHide = false;
                }

                // if(this.counter > this.productData.quantity){
                //   console.log('if if else else' ,this.productData.quantity,this.productData.total_qty,this.counter )
                //   // this.counter =  this.productData.quantity;
                  // this.isHide = false;
                  // this.is_disabled = true;
                  // this.isEnableSubmit = false;
                // }else{
                //   console.log('if if else else www')
                //   // this.counter = this.productData.total_qty ?? this.productData.quantity;
                  // this.isEnableSubmit = true;
                  // this.is_disabled = false;
                  // this.isHide = true;
                  // this.isEnable = true;
                // }
              }
              
            }
          }else{
              if(this.counter > this.productData.quantity){
                this.counter =  this.productData.quantity;
                this.isHide = false;
                this.is_disabled = true;
                this.isEnableSubmit = false;
              }else{
                this.isEnableSubmit = true;
                this.is_disabled = false;
                this.isHide = true;
                this.isEnable = true;
              }
                
          }
        }
        else{
          this.isEnableSubmit = true;
          this.is_disabled = false;
          this.isHide = true;
          this.isEnable = true;
        }
          //this.productData.quantity = this.qtyCount;
        // }else{
        //   console.log('minus');
        //   !isNaN(this.counter) && this.counter > 0 ? this.counter : this.counter = 0;
        //   //this.counter = this.counter;
        // }
      //   console.log('qtyCount',this.qtyCount);
      // console.log('counter',this.counter);
      },
      onChange(event) {
        this.isEnableSubmit = false;
         this.data_cancel = event.target.value;
  
        if(this.data_cancel == 2){
          this.isEnable = false;
        }
        else{
          this.isEnable = true;
        }
      },
      // submit(){
      //   this.productData.quantity = this.counter;
      //   this.productData.total_qty = this.qtyCount;
        
      //   if(this.cancelReason)
      //   {
      //     this.productData.reason = this.cancelReason;
      //   }
      //   else{
      //     this.productData.reason = this.data_cancel;
      //   }
        
      //  // this.$emit("cancelReason", this.cancelReason);
       
      //   orderService.adminOrderCancel(this.productData)
      //     .then(response => {
      //       if(response.data.code === 200){
      //         this.showProductModal = false;
      //         this.$emit("modelShow", this.modelShow);
      //         if(response.data.result.total_count == 1){
      //           this.$emit("actionChanged");
      //         }
      //         success_message(response.data.message);
      //       }
      //       //this.$emit("readyToCollect", this.readyToCollect);
      //   });
       
      // },

      // loadScript(url) {
      //     return new Promise((resolve, reject) => {
      //       const script = document.createElement('script');
      //       script.src = url;
      //       script.onload = () => resolve(window.Swal);
      //       script.onerror = () => reject(new Error('Script load error'));
      //       document.head.appendChild(script);
      //     });
      //   },

      //   async submit() {
      //     try {
      //       const Swal = await this.loadScript('https://cdn.jsdelivr.net/npm/sweetalert2@11');
            
      //       Swal.fire({
      //         title: 'Are you sure?',
      //         text: "Do you want to submit this information?",
      //         icon: 'warning',
      //         showCancelButton: true,
      //         confirmButtonColor: '#3085d6',
      //         cancelButtonColor: '#d33',
      //         confirmButtonText: 'Yes, submit it!',
      //         cancelButtonText: 'Cancel'
      //       }).then((result) => {
      //         if (result.isConfirmed) {
      //           // Your submit logic here
      //           Swal.fire(
      //             'Submitted!',
      //             'Your data has been submitted.',
      //             'success'
      //           );
      //         }
      //       });
      //     } catch (error) {
      //       console.error('Failed to load SweetAlert2:', error);
      //     }
      //   },
      submit() {
      this.showConfirmationModal = true; // Show confirmation modal
    },
    confirmSubmit() {
      this.productData.quantity = this.counter;
      this.productData.total_qty = this.qtyCount;

      if (this.cancelReason) {
        this.productData.reason = this.cancelReason;
      } else {
        this.productData.reason = this.data_cancel;
      }

      orderService.adminOrderCancel(this.productData)
        .then(response => {
          if (response.data.code === 200) {
            this.showProductModal = false;
            // this.$emit('modelShow', this.modelShow);
            if (response.data.result) {
              this.counter = response.data.result.pending_quantity;
              this.pendingQty= response.data.result.pending_quantity;
              this.$emit('quantityUpdate',{id :response.data.result.order_item_id ,quantity:response.data.result.pending_quantity,total_qty :response.data.result.total_quantity})
              this.$emit('actionChanged');
            }
            success_message(response.data.message);
          }
        });
    },
    cancelSubmit() {
      this.showConfirmationModal = false;
      // Optionally handle cancellation of submit action
    },
    }
}
</script>
<style scoped>
.custom-title {
  margin-bottom: 15px !important;
}
.custom-footer-buttons .btn-secondary:hover{
  color: black !important;
  border: 1px solid black !important;
  background-color: unset !important;
}
.centered-modal{
  font-size : 14px !important;
  margin: 10px 0px 70px 5px !important;
}
.centered-modal-text{
  letter-spacing:0.5px !important;
  line-height: 9.2px !important;
}
.custom-footer-buttons {
  text-align: center;
}
.custom-footer-buttons .btn-secondary {
  color: black !important;
  border: 1px solid black !important;
  background-color: unset !important;
  margin-right: 10px !important;
}
.custom-modal-body{
  padding : 2rem !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.dropdown-menu{
  scroll-behavior: smooth !important;
}
</style>